/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { Drawer, Box, styled, Typography, Divider, IconButton, Grid, Button, FormControl, InputLabel, OutlinedInput, Autocomplete, TextField, Tooltip, CircularProgress, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useState } from 'react';
import { LoadingPage } from '../../../common/LoadingPage';
import { BuildingType, defaultDoors, defaultFinishes, defaultMileWorks, defaultServices, DepartmentType } from '../../../common/const';
import { useSelector } from 'react-redux';
import { showNotification } from '../../../common/Notification/ToastifyNotification';
import { apiRequest } from '../../../common/common';
import { useEffect } from 'react';
import moment from 'moment';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import { Add, Close, Save } from '@mui/icons-material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DynamicFieldsSection from './DynamicFieldsSection';

const DemoBox1 = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 60
}));

const CustomFilterPanelWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: 10,
});

// The content area where filter controls will go
const FilterContent = styled(Box)({
    flexGrow: 1,         // Take up available space
    overflowY: 'auto',   // Enable scrolling if content overflows
    paddingBottom: 30,   // Ensure space for the fixed footer
    paddingTop: 10
});

// Footer area with fixed button
const FilterFooter = styled(Box)({
    position: 'sticky',
    bottom: 0,
    display: 'flex',
    gap: 5,
    justifyContent: 'flex-end'
});

// Fixed button in the footer
const FixedButton = styled(Button)({
    width: '100%',
});

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const Cell = styled(TableCell)({
    padding: '5px 0px 0px 0px'
});

const DocumentUploadRow = ({ label, doc, setDoc, inputId }) => {
    return (
        <TableRow>
            <Cell>{label}</Cell>
            <Cell>
                {doc && (
                    <div style={{ display: 'flex', gap: 5 }}>
                        <Typography variant='body2' color='primary'>{!doc.name ? doc[0]?.fileName : doc.name}</Typography>
                        <Tooltip title="Remove">
                            <ClearIcon
                                style={{ cursor: 'pointer', fontSize: 17, marginTop: 2 }}
                                onClick={() => {
                                    setDoc(null);
                                    document.getElementById(inputId).value = '';
                                }}
                            />
                        </Tooltip>
                    </div>
                )}
            </Cell>
            <Cell>
                <IconButton component="label" style={{ padding: 0 }}>
                    <CloudUploadIcon />
                    <VisuallyHiddenInput
                        type="file"
                        id={inputId}
                        accept=".pdf"
                        onChange={(e) => {
                            const file = e.target.files[0];
                            setDoc(file);
                        }}
                    />
                </IconButton>
            </Cell>
        </TableRow>
    );
};


export default function CreateModule({
    open,
    setOpen,
    projectData,
    getData,
    innerLabel,
    projectId,
    initialData,
    building,
    level,
    department,
    setRoomId
}) {
    const { user } = useSelector(state => state.users);
    const [dataLoading, setDataLoading] = useState(false);
    const [id, setID] = useState(null);
    const [name, setName] = useState(null);
    const [notes, setNotes] = useState(null);
    const [description, setDescription] = useState(null);
    const [type, setType] = useState(null);
    const [buildingName, setBuildingName] = useState(null);
    const [buildingData, setBuildingData] = useState([]);
    const [levelName, setLevelName] = useState(null);
    const [levelData, setLevelData] = useState([]);
    const [phaseDate, setPhaseDate] = useState(null);
    const [phaseName, setPhaseName] = useState(null);
    const [phaseData, setPhaseData] = useState([]);
    const [costName, setCostName] = useState(null);
    const [costData, setCostData] = useState([]);
    const [errors, setErrors] = useState({});
    const [phaseOpen, setPhaseOpen] = useState(false);
    const [phaseText, setPhaseText] = useState(null);
    const [costOpen, setCostOpen] = useState(false);
    const [costText, setCostText] = useState(null);
    const [roomTag, setRoomTag] = useState(null);
    const [roomSignAge, setRoomSignAge] = useState(null);
    const [roomArea, setRoomArea] = useState(null);
    const [needBy, setNeedBy] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [depName, setDepName] = useState(null);
    const [depData, setDepData] = useState([]);
    const [isLock, setIsLock] = useState(true);
    const [budgetLoading, setBudgetLoading] = useState(false);
    const [budgetData, setBudgetData] = useState([]);
    const [budgetId, setBudgetId] = useState(null);
    const [logo, setLogo] = useState(null);
    const [preview, setPreview] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [finishes, setFinishes] = useState(defaultFinishes);
    const [mileWorks, setMileWorks] = useState(defaultMileWorks);
    const [doorsData, setDoorsData] = useState(defaultDoors);
    const [services, setServices] = useState(defaultServices);
    const [doc1, setDoc1] = useState(null);
    const [doc2, setDoc2] = useState(null);
    const [doc3, setDoc3] = useState(null);
    const [doc4, setDoc4] = useState(null);
    const [doc5, setDoc5] = useState(null);


    const getBudget = async () => {
        try {
            setBudgetLoading(true);
            const response = await apiRequest('get', `/budget?projectId=${projectId}&pageNo=1&pageSize=100`);
            const { data } = response.data;
            if (data?.length > 0) {
                setBudgetData(data);
            }
            setBudgetLoading(false);
        } catch (error) {
            setBudgetLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const handleClose = () => {
        setOpen(false);
        setErrors({});
        setName(null);
        setID(null);
        setType(null);
        setBuildingName(null);
        setLevelName(null);
        setBuildingData([]);
        setLevelData([]);
        setNotes(null);
        if (setRoomId) {
            setRoomId(null);
        }
    }

    const handleSubmit = async () => {
        const newErrors = {};

        if (!name) {
            newErrors.name = `${innerLabel} Name is required`;
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            setDataLoading(true);
            if (innerLabel === 'Room') {
                const formData = new FormData();
                const rawData = {
                    room_name: name,
                    room_no: id,
                    status: 'active',
                    notes: notes,
                    room_signage: roomSignAge,
                    tags: roomTag,
                    room_area: roomArea,
                    need_by: moment(needBy).format('YYYY-MM-DDThh:mm:ssZ'),
                    quantity: Number(quantity),
                    department_id: depName,
                    level_id: levelName,
                    building_id: buildingName,
                    project_id: projectId,
                    user_id: user?.user_id,
                    type: type,
                    phase_id: phaseName,
                    cost_centre_id: costName,
                    budget_id: budgetId,
                    phase_date: phaseDate !== null ? moment(phaseDate).format('YYYY-MM-DDThh:mm:ssZ') : initialData?.phase_date ? moment(initialData?.phase_date).format('YYYY-MM-DDThh:mm:ssZ') : moment(projectData?.target_occupation).format('YYYY-MM-DDThh:mm:ssZ'),
                    organization_id: user?.organization?.organization_id,
                    description: description,
                    finishes: JSON.stringify(finishes),
                    millwork: JSON.stringify(mileWorks),
                    doorshardware: JSON.stringify(doorsData),
                    services: JSON.stringify(services)
                };
                Object.entries(rawData).forEach(([key, value]) => {
                    if (value !== null && value !== undefined && value !== '' && value !== 'Invalid date') {
                        formData.append(key, value);
                    }
                });
                if (logo !== null) {
                    formData.append('image_file', logo);
                } else {
                    formData.append('image', Array.isArray(preview) ? JSON.stringify(preview.map(item => ({
                        ...item,
                        sortUrl: item.sortUrl.split('&at=')[0]
                    }))) : "");
                }
                const appendDocumentToFormData = (formData, doc, fileKey, jsonKey) => {
                    if (doc?.name !== null) {
                        formData.append(fileKey, doc);
                    } else {
                        formData.append(jsonKey, Array.isArray(doc) ? JSON.stringify(doc.map(item => ({
                            ...item,
                            sortUrl: item.sortUrl.split('&at=')[0]
                        }))) : "");
                    }
                };

                // Usage:
                appendDocumentToFormData(formData, doc1, 'other_file_doc1', 'other_doc1');
                appendDocumentToFormData(formData, doc2, 'other_file_doc2', 'other_doc2');
                appendDocumentToFormData(formData, doc3, 'other_file_doc3', 'other_doc3');
                appendDocumentToFormData(formData, doc4, 'other_file_doc4', 'other_doc4');
                appendDocumentToFormData(formData, doc5, 'other_file_doc5', 'other_doc5');
                if (quantity >= 1) {
                    try {
                        let response;
                        if (initialData) {
                            response = await apiRequest('put', `/project-room/${initialData?.room_id}`, formData);
                        } else {
                            response = await apiRequest('post', `/project-room`, formData);
                        }
                        if (response?.data) {
                            setDataLoading(false);
                            getData();
                            showNotification(response?.data?.message, 'success');
                            handleClose();
                        }
                    } catch (error) {
                        setDataLoading(false);
                        showNotification(error?.response?.data.error || error.message, 'error');
                    }
                } else {
                    setDataLoading(false);
                    showNotification('Room QTY should be more than 1', 'error');
                }
            } else if (innerLabel === 'Department') {
                const data = {
                    department_name: name,
                    department_no: id,
                    status: 'active',
                    notes: notes,
                    level_id: levelName,
                    building_id: buildingName,
                    project_id: projectId,
                    user_id: user?.user_id,
                    type: type,
                    phase_id: phaseName,
                    cost_centre_id: costName,
                    phase_date: phaseDate !== null ? moment(phaseDate).format('YYYY-MM-DDThh:mm:ssZ') : null,
                    organization_id: user?.organization?.organization_id
                }
                try {
                    let response;
                    if (initialData) {
                        response = await apiRequest('put', `/department/${initialData?.department_id}`, data);
                    } else {
                        response = await apiRequest('post', `/department`, data);
                    }
                    if (response?.data) {
                        setDataLoading(false);
                        getData();
                        showNotification(response?.data?.message, 'success');
                        handleClose();
                    }
                } catch (error) {
                    setDataLoading(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            } else if (innerLabel === 'Level') {
                const data = {
                    level_name: name,
                    level_no: id,
                    status: 'active',
                    notes: notes,
                    building_id: buildingName,
                    project_id: projectId,
                    user_id: user?.user_id,
                    organization_id: user?.organization?.organization_id
                }
                try {
                    let response;
                    if (initialData) {
                        response = await apiRequest('put', `/level/${initialData?.level_id}`, data);
                    } else {
                        response = await apiRequest('post', `/level`, data);
                    }
                    if (response?.data) {
                        setDataLoading(false);
                        getData();
                        showNotification(response?.data?.message, 'success');
                        handleClose();
                    }
                } catch (error) {
                    setDataLoading(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            } else {
                const data = {
                    building_name: name,
                    building_no: id,
                    type: type,
                    status: 'active',
                    notes: notes,
                    project_id: projectId,
                    user_id: user?.user_id,
                    organization_id: user?.organization?.organization_id
                }
                try {
                    let response;
                    if (initialData) {
                        response = await apiRequest('put', `/building/${initialData?.building_id}`, data);
                    } else {
                        response = await apiRequest('post', `/building`, data);
                    }
                    if (response?.data) {
                        setDataLoading(false);
                        getData();
                        showNotification(response?.data?.message, 'success');
                        handleClose();
                    }
                } catch (error) {
                    setDataLoading(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            }
        }
    }

    const getBuilding = async () => {
        const url = [
            `/building?projectId=${projectId}`,
            `pageNo=1`,
            `pageSize=100`,
        ].filter(Boolean).join('&');
        try {
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setBuildingData(data);
            if (buildingName === null) {
                setBuildingName(data[0]?.building_id);
            }
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getLevel = async () => {
        const url = [
            `/level?projectId=${projectId}&buildingId=${buildingName}`,
            `pageNo=1`,
            `pageSize=100`,
        ].filter(Boolean).join('&');
        try {
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setLevelData(data);
            if (levelName === null) {
                setLevelName(data[0]?.level_id);
            }
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getDepartment = async () => {
        const url = [
            `/department?projectId=${projectId}&level_id=${levelName}`,
            `pageNo=1`,
            `pageSize=100`,
        ].filter(Boolean).join('&');
        try {
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setDepData(data);
            if (depName === null) {
                setDepName(data[0]?.department_id);
            }
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getPhase = async () => {
        try {
            const url = [
                `/department/phases?projectId=${projectId}`,
                `pageNo=1`,
                `pageSize=100`,
            ].filter(Boolean).join('&');
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setPhaseData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getCostCentre = async () => {
        try {
            const url = [
                `/department/cost-center?projectId=${projectId}`,
                `pageNo=1`,
                `pageSize=100`,
            ].filter(Boolean).join('&');
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setCostData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    useEffect(() => {
        if ((innerLabel === 'Level' || innerLabel === 'Department' || innerLabel === 'Room') && open) {
            getBuilding();
        }
    }, [innerLabel, open]);

    useEffect(() => {
        if ((innerLabel === 'Department' || innerLabel === 'Room') && buildingName !== null && open) {
            getLevel();
            getPhase();
            getCostCentre();
            if (innerLabel === 'Room') {
                getBudget();
            }
        }
    }, [open, buildingName]);

    useEffect(() => {
        if ((innerLabel === 'Room') && levelName !== null && open) {
            getDepartment();
        }
    }, [open, levelName]);

    useEffect(() => {
        setID(initialData?.building_no || initialData?.level_no || initialData?.department_no || initialData?.room_no || null);
        setName(initialData?.building_name || initialData?.level_name || initialData?.department_name || initialData?.room_name || null);
        setNotes(initialData?.notes || null);
        setDescription(initialData?.description || null);
        setType(initialData?.type || (innerLabel === 'Building' ? BuildingType[0]?.value : DepartmentType[0]?.value));
        setBuildingName(building?.building_id || initialData?.building_id || level?.building?.building_id || initialData?.building?.building_id || department?.building?.building_id || null);
        setLevelName(level?.level_id || initialData?.level_id || department?.level_id || initialData?.level_id || null);
        setPhaseDate(initialData?.phase_date ? moment(initialData?.phase_date).format('YYYY-MM-DD') : moment(projectData?.target_occupation).format('YYYY-MM-DD'));
        setPhaseName(initialData?.phase_id || null);
        setCostName(initialData?.cost_centre_id || null);
        setRoomTag(initialData?.tags || null);
        setRoomSignAge(initialData?.room_signage || null);
        setRoomArea(initialData?.room_area || null);
        setNeedBy(initialData?.need_by ? moment(initialData?.need_by).format('YYYY-MM-DD') : moment(projectData?.target_occupation).format('YYYY-MM-DD'));
        setQuantity(initialData?.quantity || 1);
        setDepName(department?.department_id || initialData?.department_id || null);
        setBudgetId(initialData?.budget_id || null);
        setFinishes(initialData?.finishes ? JSON.parse(initialData?.finishes) : defaultFinishes);
        setMileWorks(initialData?.millwork ? JSON.parse(initialData?.millwork) : defaultMileWorks);
        setDoorsData(initialData?.doorshardware ? JSON.parse(initialData?.doorshardware) : defaultDoors);
        setServices(initialData?.services ? JSON.parse(initialData?.services) : defaultServices);
        const parseDoc = (docField) => {
            if (docField) {
                return typeof docField !== 'string' ? docField : JSON.parse(docField);
            }
            return null;
        };

        setPreview(parseDoc(initialData?.image));
        setDoc1(parseDoc(initialData?.other_doc1));
        setDoc2(parseDoc(initialData?.other_doc2));
        setDoc3(parseDoc(initialData?.other_doc3));
        setDoc4(parseDoc(initialData?.other_doc4));
        setDoc5(parseDoc(initialData?.other_doc5));
    }, [initialData, building, level, department, projectData, innerLabel]);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        setLogo(file);
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            setPreview(null);
        }
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setFinishes(defaultFinishes);
        setMileWorks(defaultMileWorks);
        setDoorsData(defaultDoors);
        setServices(defaultServices);
        setDoc1(null);
        setDoc2(null);
        setDoc3(null);
        setDoc4(null);
        setDoc5(null);
    }

    return (
        <>
            <Drawer
                anchor="right"
                open={dialogOpen}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: '60%'
                    }
                }}
            >
                <CustomFilterPanelWrapper>
                    {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
                    <DemoBox1>
                        <Typography variant='body1' style={{ fontWeight: 'bold' }}>Additional Information</Typography>
                        <IconButton onClick={() => handleDialogClose()}>
                            <ClearIcon />
                        </IconButton>
                    </DemoBox1>
                    <Divider />
                    <FilterContent>
                        <DynamicFieldsSection
                            title="Finishes"
                            data={finishes}
                            setData={setFinishes}
                            showNotification={showNotification}
                        />

                        <DynamicFieldsSection
                            title="Millwork"
                            data={mileWorks}
                            setData={setMileWorks}
                            showNotification={showNotification}
                        />

                        <DynamicFieldsSection
                            title="Doors and Hardware"
                            data={doorsData}
                            setData={setDoorsData}
                            showNotification={showNotification}
                            fromDoors
                        />

                        <DynamicFieldsSection
                            title="Services"
                            data={services}
                            setData={setServices}
                            showNotification={showNotification}
                            fromService
                            categoryOptions={['IT / Communications',
                                'Electrical / Lighting',
                                'Electrical / Power',
                                'Mechanical / HVAC',
                                'Mechanical / Plumbing',
                                'MedGas']}
                        />

                        <Box className="dfs-container">
                            <Typography variant="body1" className="dfs-title" style={{ fontWeight: 'bold' }}>
                                Resources: <span style={{ fontSize: 10, fontWeight: 'normal', color: 'red' }}>Please insert the PDFs in the sequence you would prefer it to appear in the final report</span>
                            </Typography>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <Cell>Type</Cell>
                                        <Cell>Resource</Cell>
                                        <Cell>Action</Cell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <Cell>Image</Cell>
                                        <Cell>
                                            {preview && (
                                                <div style={{ position: 'relative' }}>
                                                    <img src={Array.isArray(preview) ? `${process.env.REACT_APP_IMAGEURL}bbn=${preview?.[0]?.sortUrl}&uid=${user?.user_id}` : preview} alt="Preview" style={{ maxWidth: '100px', height: 'auto' }} />
                                                    <Tooltip title="remove image">
                                                        <ClearIcon
                                                            style={{
                                                                cursor: 'pointer',
                                                                position: 'absolute',
                                                                left: 80,
                                                                fontSize: 17
                                                            }}
                                                            onClick={async () => {
                                                                setLogo(null);
                                                                setPreview(null);
                                                                document.getElementById('imageInput').value = '';
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </div>
                                            )}
                                        </Cell>
                                        <Cell>
                                            <IconButton component="label" style={{ padding: 0 }}>
                                                <CloudUploadIcon />
                                                <VisuallyHiddenInput
                                                    type="file"
                                                    id="imageInput"
                                                    onChange={(event) => handleFileUpload(event)}
                                                    accept=".jpeg,.jpg,.png,.PNG"
                                                />
                                            </IconButton>
                                        </Cell>
                                    </TableRow>
                                    <DocumentUploadRow label="Attachment 1" doc={doc1} setDoc={setDoc1} inputId="doc1" />
                                    <DocumentUploadRow label="Attachment 2" doc={doc2} setDoc={setDoc2} inputId="doc2" />
                                    <DocumentUploadRow label="Attachment 3" doc={doc3} setDoc={setDoc3} inputId="doc3" />
                                    <DocumentUploadRow label="Attachment 4" doc={doc4} setDoc={setDoc4} inputId="doc4" />
                                    <DocumentUploadRow label="Attachment 5" doc={doc5} setDoc={setDoc5} inputId="doc5" />
                                </TableBody>
                            </Table>
                        </Box>
                    </FilterContent>
                    <FilterFooter>
                        <Button variant="outlined" color="primary" onClick={() => handleDialogClose()}>Cancel</Button>
                        <Button variant="contained" color="primary" onClick={() => setDialogOpen(false)}>Submit</Button>
                    </FilterFooter>
                </CustomFilterPanelWrapper>
            </Drawer>
            <Drawer
                anchor="right"
                open={open}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: 350
                    }
                }}
            >
                <CustomFilterPanelWrapper>
                    {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
                    <DemoBox1>
                        <Typography variant='body1' style={{ fontWeight: 'bold' }}>{`${initialData ? 'Edit' : 'Create '} ${innerLabel}`}</Typography>
                        <IconButton onClick={() => handleClose()}>
                            <ClearIcon />
                        </IconButton>
                    </DemoBox1>
                    <Divider />
                    <FilterContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl size="small" variant="outlined" fullWidth>
                                    <InputLabel htmlFor="standard-adornment-password">{`${innerLabel} Name *`}</InputLabel>
                                    <OutlinedInput
                                        label={`${innerLabel} Name *`}
                                        id="standard-adornment-password"
                                        type='text'
                                        value={name || ''}
                                        onChange={(e) => {
                                            const newErrors = errors;
                                            if (!e.target.value) {
                                                newErrors.name = `${innerLabel} Name is required`;
                                            } else {
                                                newErrors.name = '';
                                            }
                                            setErrors(newErrors);
                                            setName(e.target.value);
                                        }}
                                    />
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.name}</Typography>
                                </FormControl>
                            </Grid>
                            {innerLabel === 'Building' && (
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Autocomplete
                                        value={BuildingType.find((c) => c.value === type) || null}
                                        id="combo-box-demo"
                                        size="small"
                                        fullWidth
                                        clearIcon={null}
                                        options={BuildingType}
                                        getOptionLabel={(option) => option.name}
                                        onChange={(event, newValue) => {
                                            setType(newValue?.value || null);
                                        }}
                                        renderInput={(params) => <TextField fullWidth {...params} label={`${innerLabel} Type *`} name={`${innerLabel} Type *`} variant="outlined" />}
                                    />
                                </Grid>
                            )}
                            {innerLabel === 'Department' && (
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Autocomplete
                                        value={DepartmentType.find((c) => c.value === type) || null}
                                        id="combo-box-demo"
                                        size="small"
                                        fullWidth
                                        clearIcon={null}
                                        options={DepartmentType}
                                        getOptionLabel={(option) => option.name}
                                        onChange={(event, newValue) => {
                                            setType(newValue?.value || null);
                                        }}
                                        renderInput={(params) => <TextField fullWidth {...params} label={`${innerLabel} Type *`} name={`${innerLabel} Type *`} variant="outlined" />}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={12}>
                                <FormControl size="small" variant="outlined" fullWidth>
                                    <InputLabel htmlFor="standard-adornment-password">{innerLabel !== 'Room' ? `${innerLabel} ID` : `${innerLabel} No`}</InputLabel>
                                    <OutlinedInput
                                        label={`${innerLabel} ID`}
                                        id="standard-adornment-password"
                                        type='text'
                                        value={id || ''}
                                        onChange={(e) => {
                                            setID(e.target.value);
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            {innerLabel === 'Room' && (
                                <>
                                    <Grid item xs={12}>
                                        <FormControl size="small" variant="outlined" fullWidth>
                                            <InputLabel htmlFor="standard-adornment-password">Description</InputLabel>
                                            <OutlinedInput
                                                multiline
                                                maxRows={5}
                                                minRows={4}
                                                label="Description"
                                                id="standard-adornment-password"
                                                type='text'
                                                value={description || ''}
                                                onChange={(e) => {
                                                    setDescription(e.target.value);
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl size="small" variant="outlined" fullWidth>
                                            <InputLabel htmlFor="standard-adornment-password">Tags</InputLabel>
                                            <OutlinedInput
                                                label="Tags"
                                                id="standard-adornment-password"
                                                type='text'
                                                value={roomTag || ''}
                                                onChange={(e) => {
                                                    setRoomTag(e.target.value);
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl size="small" variant="outlined" fullWidth>
                                            <InputLabel htmlFor="standard-adornment-password">Room SignAge</InputLabel>
                                            <OutlinedInput
                                                label="Room SignAge"
                                                id="standard-adornment-password"
                                                type='text'
                                                value={roomSignAge || ''}
                                                onChange={(e) => {
                                                    setRoomSignAge(e.target.value);
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl size="small" variant="outlined" fullWidth>
                                            <InputLabel htmlFor="standard-adornment-password">Quantity</InputLabel>
                                            <OutlinedInput
                                                label="Quantity"
                                                id="standard-adornment-password"
                                                type='number'
                                                value={quantity || ''}
                                                onChange={(e) => {
                                                    setQuantity(e.target.value);
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl size="small" variant="outlined" fullWidth>
                                            <InputLabel htmlFor="standard-adornment-password">{`Room Area (${projectData?.default_project_units === 'matric' ? 'sq.mt' : 'sq.ft'})`}</InputLabel>
                                            <OutlinedInput
                                                label={`Room Area (${projectData?.default_project_units === 'matric' ? 'sq.mt' : 'sq.ft'})`}
                                                id="standard-adornment-password"
                                                type='number'
                                                value={roomArea || ''}
                                                onChange={(e) => {
                                                    setRoomArea(e.target.value);
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl size="small" variant="outlined" fullWidth>
                                            <InputLabel htmlFor="standard-adornment-password">{`Total Room Area (${projectData?.default_project_units === 'matric' ? 'sq.mt' : 'sq.ft'})`}</InputLabel>
                                            <OutlinedInput
                                                label={`Total Room Area (${projectData?.default_project_units === 'matric' ? 'sq.mt' : 'sq.ft'})`}
                                                id="standard-adornment-password"
                                                type='number'
                                                value={roomArea ? Number(roomArea * quantity) : ''}
                                                disabled
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <FormControl size="small" fullWidth variant="outlined">
                                                <InputLabel htmlFor="standard-adornment-password" shrink={needBy === null || needBy === '' || needBy}>Need By</InputLabel>
                                                <OutlinedInput
                                                    label="Need By"
                                                    id="need by"
                                                    type='date'
                                                    disabled={isLock}
                                                    value={needBy || ''}
                                                    onChange={(e) => {
                                                        setNeedBy(e.target.value);
                                                    }}
                                                />
                                            </FormControl>
                                            {isLock ? (
                                                <Tooltip title="Unlock need by date" onClick={() => {
                                                    setIsLock(false);
                                                }}>
                                                    <IconButton>
                                                        <LockIcon color="primary" />
                                                    </IconButton>
                                                </Tooltip>
                                            ) : (
                                                <Tooltip title="Lock need by date" onClick={() => {
                                                    setIsLock(true);
                                                }}>
                                                    <IconButton>
                                                        <LockOpenIcon color="primary" />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </Box>
                                    </Grid>
                                </>
                            )}
                            {(innerLabel === 'Level' || innerLabel === 'Department' || innerLabel === 'Room') && (
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Autocomplete
                                        value={buildingData.find((c) => c.building_id === buildingName) || null}
                                        id="combo-box-demo"
                                        size="small"
                                        fullWidth
                                        clearIcon={null}
                                        options={buildingData}
                                        getOptionLabel={(option) => option.building_name}
                                        onChange={(event, newValue) => {
                                            setBuildingName(newValue?.building_id || null);
                                        }}
                                        renderInput={(params) => <TextField fullWidth {...params} label="Building Name *" name="Building Name *" variant="outlined" />}
                                    />
                                </Grid>
                            )}
                            {(innerLabel === 'Department' || innerLabel === 'Room') && (
                                <>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Autocomplete
                                            value={levelData.find((c) => c.level_id === levelName) || null}
                                            id="combo-box-demo"
                                            size="small"
                                            fullWidth
                                            clearIcon={null}
                                            options={levelData}
                                            getOptionLabel={(option) => option.level_name}
                                            onChange={(event, newValue) => {
                                                setLevelName(newValue?.level_id || null);
                                            }}
                                            renderInput={(params) => <TextField fullWidth {...params} label="Level Name *" name="Level Name *" variant="outlined" />}
                                        />
                                    </Grid>
                                    {innerLabel === 'Room' && (
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <Autocomplete
                                                value={depData.find((c) => c.department_id === depName) || null}
                                                id="combo-box-demo"
                                                size="small"
                                                fullWidth
                                                clearIcon={null}
                                                options={depData}
                                                getOptionLabel={(option) => option.department_name}
                                                onChange={(event, newValue) => {
                                                    setDepName(newValue?.department_id || null);
                                                }}
                                                renderInput={(params) => <TextField fullWidth {...params} label="Department Name *" name="Department Name *" variant="outlined" />}
                                            />
                                        </Grid>
                                    )}
                                    {innerLabel === 'Room' && (
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <Autocomplete
                                                value={budgetData.find((c) => c.budget_id === budgetId) || null}
                                                id="combo-box-demo"
                                                size="small"
                                                fullWidth
                                                options={budgetData}
                                                getOptionLabel={(option) => option?.budget_name}
                                                onChange={(event, newValue) => {
                                                    setBudgetId(newValue?.budget_id || null)
                                                }}
                                                renderInput={(params) =>
                                                    <TextField
                                                        fullWidth
                                                        {...params}
                                                        label="Budget"
                                                        name="Budget"
                                                        variant="outlined"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {budgetLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        }}
                                                    />}
                                            />
                                        </Grid>
                                    )}
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            {phaseOpen ? (
                                                <>
                                                    <FormControl size="small" variant="outlined" fullWidth>
                                                        <InputLabel htmlFor="standard-adornment-password">Phase Name</InputLabel>
                                                        <OutlinedInput
                                                            label="Phase Name"
                                                            id="standard-adornment-password"
                                                            type='text'
                                                            value={phaseText || ''}
                                                            onChange={(e) => {
                                                                setPhaseText(e.target.value);
                                                            }}
                                                        />
                                                    </FormControl>
                                                    <Tooltip title="Save" onClick={async () => {
                                                        if (phaseText) {
                                                            setDataLoading(true);
                                                            const data = {
                                                                "phase_name": phaseText,
                                                                "description": phaseText,
                                                                "phase_date": moment(phaseDate).format('YYYY-MM-DDThh:mm:ssZ'),
                                                                "user_id": user?.user_id,
                                                                "organization_id": user?.organization?.organization_id,
                                                                "project_id": projectId,
                                                                "status": "active"
                                                            }
                                                            try {
                                                                const response = await apiRequest('post', `/department/phase`, data);
                                                                if (response?.data) {
                                                                    setDataLoading(false);
                                                                    getPhase();
                                                                    showNotification(response?.data?.message, 'success');
                                                                    setPhaseOpen(false);
                                                                    setPhaseText(null);
                                                                }
                                                            } catch (error) {
                                                                setDataLoading(false);
                                                                showNotification(error?.response?.data.error || error.message, 'error');
                                                            }
                                                        } else {
                                                            showNotification('Please enter phase name', 'error');
                                                        }
                                                    }}>
                                                        <IconButton>
                                                            <Save color="primary" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Cancel" onClick={() => {
                                                        setPhaseOpen(false);
                                                    }}>
                                                        <IconButton>
                                                            <Close color="secondary" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </>
                                            ) : (
                                                <>
                                                    <Autocomplete
                                                        value={phaseData.find((c) => c.phase_id === phaseName) || null}
                                                        id="combo-box-demo"
                                                        size="small"
                                                        fullWidth
                                                        options={phaseData}
                                                        getOptionLabel={(option) => option.phase_name}
                                                        onChange={(event, newValue) => {
                                                            setPhaseDate(newValue?.phase_date ? moment(newValue?.phase_date).format('YYYY-MM-DD') : null);
                                                            setPhaseName(newValue?.phase_id || null);
                                                        }}
                                                        renderInput={(params) => <TextField fullWidth {...params} label="Area/Phase Name" name="Area/Phase Name" variant="outlined" />}
                                                    />
                                                    <Tooltip title="Add Phase" onClick={() => {
                                                        setPhaseOpen(true);
                                                    }}>
                                                        <IconButton>
                                                            <Add color="primary" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </>
                                            )}
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <FormControl size="small" fullWidth variant="outlined">
                                            <InputLabel htmlFor="standard-adornment-password" shrink={phaseDate === null || phaseDate === '' || phaseDate}>Area/Phase Date</InputLabel>
                                            <OutlinedInput
                                                label="Area/Phase Date"
                                                id="Area/Phase Date"
                                                type='date'
                                                disabled={!phaseOpen}
                                                value={phaseDate || ''}
                                                onChange={(e) => {
                                                    setPhaseDate(e.target.value);
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            {costOpen ? (
                                                <>
                                                    <FormControl size="small" variant="outlined" fullWidth>
                                                        <InputLabel htmlFor="standard-adornment-password">Cost Centre Name</InputLabel>
                                                        <OutlinedInput
                                                            label="Cost Centre Name"
                                                            id="standard-adornment-password"
                                                            type='text'
                                                            value={costText || ''}
                                                            onChange={(e) => {
                                                                setCostText(e.target.value);
                                                            }}
                                                        />
                                                    </FormControl>
                                                    <Tooltip title="Save" onClick={async () => {
                                                        if (costText) {
                                                            setDataLoading(true);
                                                            const data = {
                                                                "cost_centre_name": costText,
                                                                "description": costText,
                                                                "user_id": user?.user_id,
                                                                "organization_id": user?.organization?.organization_id,
                                                                "project_id": projectId,
                                                                "status": "active"
                                                            }
                                                            try {
                                                                const response = await apiRequest('post', `/department/cost-center`, data);
                                                                if (response?.data) {
                                                                    setDataLoading(false);
                                                                    getCostCentre();
                                                                    showNotification(response?.data?.message, 'success');
                                                                    setCostOpen(false);
                                                                    setCostText(null);
                                                                }
                                                            } catch (error) {
                                                                setDataLoading(false);
                                                                showNotification(error?.response?.data.error || error.message, 'error');
                                                            }
                                                        } else {
                                                            showNotification('Please enter phase name', 'error');
                                                        }
                                                    }}>
                                                        <IconButton>
                                                            <Save color="primary" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Cancel" onClick={() => {
                                                        setCostOpen(false);
                                                    }}>
                                                        <IconButton>
                                                            <Close color="secondary" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </>
                                            ) : (
                                                <>
                                                    <Autocomplete
                                                        value={costData.find((c) => c.cost_centre_id === costName) || null}
                                                        id="combo-box-demo"
                                                        size="small"
                                                        fullWidth
                                                        clearIcon={null}
                                                        options={costData}
                                                        getOptionLabel={(option) => option.cost_centre_name}
                                                        onChange={(event, newValue) => {
                                                            setCostName(newValue?.cost_centre_id || null);
                                                        }}
                                                        renderInput={(params) => <TextField fullWidth {...params} label="Cost Centre" name="Cost Centre" variant="outlined" />}
                                                    />
                                                    <Tooltip title="Add Cost Centre" onClick={() => {
                                                        setCostOpen(true);
                                                    }}>
                                                        <IconButton>
                                                            <Add color="primary" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </>
                                            )}
                                        </Box>
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={12}>
                                <FormControl size="small" variant="outlined" fullWidth>
                                    <InputLabel htmlFor="standard-adornment-password">Notes</InputLabel>
                                    <OutlinedInput
                                        multiline
                                        maxRows={5}
                                        minRows={4}
                                        label="Notes"
                                        id="standard-adornment-password"
                                        type='text'
                                        value={notes || ''}
                                        onChange={(e) => {
                                            setNotes(e.target.value);
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            {innerLabel === 'Room' && (
                                <Grid item xs={12}>
                                    <Button
                                        size='Medium'
                                        color='primary'
                                        variant='contained'
                                        startIcon={<Add />}
                                        onClick={() => setDialogOpen(true)}
                                        style={{ float: 'right' }}
                                    >
                                        More Details
                                    </Button>
                                </Grid>)}
                        </Grid>
                    </FilterContent>
                    <FilterFooter>
                        <FixedButton variant="outlined" color="primary" onClick={() => handleClose()}>Cancel</FixedButton>
                        <FixedButton variant="contained" color="primary" onClick={() => handleSubmit()}>Save</FixedButton>
                    </FilterFooter>
                </CustomFilterPanelWrapper>
            </Drawer>
        </>
    );
}